import de from '@translations/de/productsTable.json';
import en from '@translations/en/productsTable.json';
import pl from '@translations/pl/productsTable.json';
import sl from '@translations/sl/productsTable.json';
import uk from '@translations/uk/productsTable.json';
import bg from '@translations/bg/productsTable.json';
import cz from '@translations/cz/productsTable.json';
import fr from '@translations/fr/productsTable.json';
import gr from '@translations/gr/productsTable.json';
import it from '@translations/it/productsTable.json';
import pr from '@translations/pr/productsTable.json';
import ru from '@translations/ru/productsTable.json';
import sk from '@translations/sk/productsTable.json';
import sp from '@translations/sp/productsTable.json';
import tr from '@translations/tr/productsTable.json';
import hu from '@translations/hu/productsTable.json';
import { ITranslations } from '@/types/common';
import { ProductsTableTransFields } from './types';

export const productsTableTranslations: ITranslations<ProductsTableTransFields> = {
  name: 'productsTable',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
